export let routes = [
  {
    path: '/x3-side-student',
    name: 'x3-side-student',
    component: () => import('@x3/js/side/student/student.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-student-filtrate',
    name: 'x3-side-student-filtrate',
    component: () => import('@x3/js/side/student/filtrate/filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-student-more-filtrate',
    name: 'x3-side-student-more-filtrate',
    component: () => import('@x3/js/side/student/filtrate/filtrate2.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsStudent(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-student',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsStudentFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-student-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsStudentMoreFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-student-more-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  }
};
